(() => {
  document.querySelectorAll('.sw-testimonials').forEach((root) => {
    const track = root.querySelector('.sw-testimonials__track');
    const prev  = root.querySelector('.sw-testimonials__arrow--prev');
    const next  = root.querySelector('.sw-testimonials__arrow--next');
    if (!track) return;

    // Retorna el ancho efectivo de una card (+ gap) para el scrollBy
    const cardScrollWidth = () => {
      const isMobile = window.innerWidth <= 749;
      const selector = isMobile
        ? '.sw-testimonials__card:not(.sw-testimonials__card--hide-mobile)'
        : '.sw-testimonials__card';
      const card = track.querySelector(selector);
      if (!card) return track.clientWidth * 0.82;
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card.getBoundingClientRect().width + gap;
    };

    // Actualiza el estado disabled de las flechas según posición del scroll
    const updateArrows = () => {
      if (!prev && !next) return;
      const atStart = track.scrollLeft <= 2;
      const atEnd   = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    };

    if (prev) {
      prev.addEventListener('click', () => {
        track.scrollBy({ left: -cardScrollWidth(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        track.scrollBy({ left: cardScrollWidth(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    // Visibilidad de flechas en mobile según configuración de la sección
    const arrowsMobile = root.dataset.arrowsMobile === 'true';
    if (!arrowsMobile) {
      const mq = window.matchMedia('(max-width: 749px)');
      const syncArrowVisibility = () => {
        const hide = mq.matches;
        [prev, next].forEach((btn) => {
          if (btn) btn.style.display = hide ? 'none' : '';
        });
      };
      syncArrowVisibility();
      mq.addEventListener('change', syncArrowVisibility);
    }

    // ── Drag con mouse en desktop ──────────────────────────────────────────
    let isDragging = false;
    let startX     = 0;
    let startScroll = 0;
    let dragDelta  = 0;

    track.addEventListener('pointerdown', (e) => {
      // Solo mouse/pen, no touch (el touch usa scroll nativo)
      if (e.pointerType === 'touch') return;
      isDragging  = true;
      dragDelta   = 0;
      startX      = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
      track.style.cursor = 'grabbing';
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDragging) return;
      const dx   = e.clientX - startX;
      dragDelta  = Math.abs(dx);
      track.scrollLeft = startScroll - dx;
    });

    const stopDrag = () => {
      isDragging = false;
      track.style.cursor = '';
    };

    track.addEventListener('pointerup',     stopDrag);
    track.addEventListener('pointercancel', stopDrag);

    // Cancelar clicks que fueron arrastres reales (umbral 5px)
    track.addEventListener('click', (e) => {
      if (dragDelta > 5) e.preventDefault();
    }, true);

    // Estado inicial de flechas
    updateArrows();
  });
})();
